module.exports = __webpack_public_path__ + "316701a38e60e1d77c5d029943dbac8d.png";